export const BLACK_FRIDAY_2021_ID = '--black-friday-2021--'
export const BLACK_FRIDAY_2022_ID = 'black-friday-2022'
export const BLACK_FRIDAY_2023_ID = 'black-friday-2023'
export const EARLY_BIRD_SALE_2023_ID = 'early-bird-sale-2023'

export const EVENT_STATUS_CREATED = 'CREATED'
export const EVENT_STATUS_ONGOING = 'ONGOING'
export const EVENT_STATUS_ENDED = 'ENDED'